<div
  class="pointer-events-none"
  [ngStyle]="contentStyle"
  [ngClass]="[baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : '', 'w-100']"
>
  <div class="w-100">
    @if (!showFetchingState) {
      @if (hasOfficers) {
        @for (option of officerOptions; track option.value) {
          <finxone-web-frontend-list-item
            [content]="widgetProperties['listItemTemplate']"
            [customHandlebarModel]="buildHandlebarCustomModel(option, $index)"
            [class.selected]="option.value === selectedValue"
            (itemClicked)="onSelectOfficer(option)"
          ></finxone-web-frontend-list-item>
        }
      } @else {
        <div [innerHTML]="noResultsContent | safeHtml"></div>
      }
    } @else {
      <div [innerHTML]="fetchingTemplate | safeHtml"></div>
    }
  </div>
</div>
